/* eslint-disable react/react-in-jsx-scope */
import {Col, Row,Space,Typography,Tooltip,DatePicker,Breadcrumb,Tabs,Button} from 'antd';
import { Content } from 'antd/es/layout/layout';

import { useLocation } from 'react-router-dom';
import TabPane from 'antd/es/tabs/TabPane';
import Loghistory from './loghistory';
import Tasknavigation from './tasks';

import {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import dayjs from 'dayjs';

import { HomeOutlined,FileSearchOutlined,PlusOutlined,CarryOutOutlined} from '@ant-design/icons';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';

import Schedule from './Schedule';
import Path from './path';

const { RangePicker } = DatePicker;

export default function Detailspage() {
	
	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	
	const {Title} =Typography;
	const location = useLocation();
	const {userId, usertypeId, allocationsList,allocations, usertype , path , username , pipelineId } = location.state||{};
	const navigate = useNavigate();
	
	useAuth();
	const [tabkey,setTabkey] = useState('1');
	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	// const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	// const [endDate, setEndDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	
	const [showaddmodal,setShowAddModal]=   useState(false);
	const [showScheduleAddModal, setShowScheduleAddModal] = useState(false);
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envstsEnable = process.env.REACT_APP_STS == undefined || process.env.REACT_APP_STS == 'undefined' ? 'false' : process.env.REACT_APP_STS;
	const stsEnable = localStorage.getItem(`${dashboardtype.toUpperCase()}_APP_STS`) == 'null' ? envstsEnable : localStorage.getItem(`${dashboardtype.toUpperCase()}_APP_STS`);
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}

	},[authtoken]);

	

	const closeAddScheduleModal = ()=>{
		setShowScheduleAddModal(false);
	};

	const closeTasklistmodal = () => {
		setShowAddModal(false);
	};

	function setthisTitle(activeKey){
		
		setTabkey(activeKey);
		if (activeKey){
			setStartDate(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
			setEndDate(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
		
		}
	}
	

	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
		
			}else{
						
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
		
			}
		} else {
			console.log('Clear');
		}
	};
	
	const getDateWithTime = (date, time) => {
		if (!time) return date;
	
		const [hour, minute, second] = time.split(':').map(Number);
	
		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};

	return (
		<>
			{location.state ? (
				<Content>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title:
												path === 'allocations' ? (
													<a onClick={() => navigate(-1)}>
														{langdata&&langdata.Allocations?langdata.Allocations: 'Allocations'}
													</a>
												) :null},
							{
								title: `${tabkey==1?langdata&&langdata.Logs?langdata.Logs:'Logs': tabkey==2 ?langdata&&langdata.Task?langdata.Task:'Tasks' : tabkey==3 ? langdata&&langdata.Schedule?langdata.Schedule :'Schedule' : langdata&&langdata.OptionalPath?langdata.OptionalPath :'Optional Path'} - ${username}`
							},
						]}
						style={{ margin: '10px' }}
					/>
					<Row
						style={{
							margin: '10px',
							paddingLeft: '10px',
							paddingRight: '10px',
							background: '#FFFFFF',
							alignItems:'center',
						}}
					>
	
	
						<Col span={10}>
							<Row>
	
								<Space>
									{tabkey==1?<FileSearchOutlined style={{fontSize:'30px'}}/>:<CarryOutOutlined  style={{fontSize:'30px'}}/>}
								</Space>
	
								<Space>&nbsp;&nbsp;</Space>
						
						
								<Title level={4} style={{ paddingTop:'10px'}}>{tabkey==1?langdata&&langdata.Logs?langdata.Logs:'Logs': tabkey==2 ?langdata&&langdata.Task?langdata.Task:'Tasks' : tabkey==3 ? langdata&&langdata.Schedule?langdata.Schedule :'Schedule' : langdata&&langdata.PathName?langdata.PathName :'PathName'}</Title>
							</Row>
						</Col>
						<Col style ={{justifyContent:'right', display:'flex'}} span={14} >
							<Row>
								<Col span={24}>
								
										
	
									<Space>
										{tabkey == 4 ? null : <Tooltip title={moment(startDate).format(settingsdateformat) + ' - ' + moment(endDate).format(settingsdateformat)} placement='bottom'>
										
											<RangePicker  onChange={onRangeChange} 
												allowClear={false}
												showTime
												format={`${settingsdateformat} ${settingstimeformat}`}
												defaultValue={[
													getDateWithTime(dayjs().subtract(30, 'day'), customstart),
													getDateWithTime(dayjs(), customend)
												]}
														
												// defaultValue={[dayjs(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30)),dayjs(new Date())]}
												// disabledDate={disabledDate}
											/>
										</Tooltip>}
										
									</Space>
											
											
									
									<>
										{tabkey == 2 ?
					
											<>
												<Space>&nbsp;&nbsp;</Space>

												<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
													<Space>
														{ permission === 'superadmin' || permission === 'admin'||permission === 'ROU' || permission === 'CRO' ? <Button type="primary" onClick={()=>{setShowAddModal(true);}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
													</Space>
												</Tooltip>
											</>
												
											:
												
											null }
											
									</>
									<>
										{tabkey == 3 ?
					
											
											<>
												<Space>&nbsp;&nbsp;</Space>
												<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
													<Space>
														{ permission === 'superadmin' || permission === 'admin'||permission === 'ROU' || permission === 'CRO' ? <Button type="primary" onClick={()=>{setShowScheduleAddModal(true);}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
													</Space>
												</Tooltip>
											</>
											:
												
											null }
											
									</>
									<>
										{tabkey == 4 ?
					
											<>
												<Space>&nbsp;&nbsp;</Space>
												<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
													<Space>
														<Button type='primary'  title="Edit Allocation"  onClick={() => {navigate(( '/edit-allocation-pipeline-path'),{ state: { userId : userId , path : 'Optional Path' }});}}>{langdata && langdata.EditPipelinePath ? langdata.EditPipelinePath : 'Edit Path'}</Button>

													</Space>
												</Tooltip></>
												
											:
												
											null }
											
									</>
	

								</Col>
							</Row>
						</Col>
						{/* </Space> */}
					</Row>
						
	
					<Row span={24} style={{
						margin: '10px',
							
					
						background: '#FFFFFF',
							
					}}>
						<Col span={24}  >
							
									
							<Tabs style={{
								margin: '10px',
								paddingLeft: '10px',
								paddingRight: '10px',
								background: '#FFFFFF',
							}} defaultActiveKey={1} onChange={setthisTitle} >
	
								<TabPane key={1} tab={langdata.Logs || 'Logs'} >
									{tabkey == 1 ?
										<Loghistory userId={userId} startDate={startDate} endDate={endDate} activetab ={tabkey} pipelineId = {pipelineId} /> :
										null }
	
								</TabPane>
								{
									featuresModule.scheduleManagementEnabled ? 
								
										<TabPane key={3} tab={langdata.Schedule || 'Schedule'} >
											{ tabkey == 3 ?
												<Schedule userId={userId} startDate={startDate} endDate={endDate} activetab ={tabkey} pipelineId = {pipelineId} setShowScheduleAddModal={setShowScheduleAddModal} closeAddScheduleModal = {closeAddScheduleModal} showScheduleAddModal={showScheduleAddModal}/> :
												null }
	
										</TabPane> : null}

	
								{(usertype==='nightpatrol' || usertype==='linewalker' || usertype==='QRT')&& (allocationsList == true ) && featuresModule.taskManagementEnabled && (stsEnable == 'true' || dashboardtype == 'sts') ?
									<TabPane key={2} tab={langdata.Task || 'Task'} >
										{tabkey == 2 ?
											<Tasknavigation userId={userId} allocations={allocations}  usertypeId={usertypeId}  showaddmodal ={showaddmodal} 
												closeTasklistmodal={closeTasklistmodal}  setShowAddModal={setShowAddModal}  startDate={startDate} 
												endDate={endDate}
												activetab ={tabkey} />
											: null }
									</TabPane>
	
									:
									null	
								}

								{(usertype==='nightpatrol' || usertype==='linewalker' || usertype==='QRT') && allocationsList == true && (stsEnable == 'true' || dashboardtype == 'sts') ?
									<TabPane key={4} tab={langdata.OptionalPath || 'Optional Path'} >
										{tabkey == 4 ?
											<Path userId={userId} allocations={allocations}
												activetab ={tabkey} startDate={startDate} endDate={endDate} />
											: null }
									</TabPane>
	
									:
									null	
								}
							</Tabs>
							
						</Col>
					</Row>
	
					
	
				</Content>
				
				
			) : null}
		</>
	);
}




	
		




	
	
	
	

	


	



	